import type { GroupPostContentObjectList } from 'models';
import { Flex } from 'ui';
import { LikeButton } from 'features/like';

type P = {
  item: GroupPostContentObjectList;
};

const GroupActionBar = ({ item }: P) => (
  <Flex justify="space-evenly">
    <LikeButton contentObject={item} type="action" />
  </Flex>
);

export default GroupActionBar;
